import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { ConversationContext } from '../contexts/ConversationContext';


const NutzungsrichtlinienContainer = styled.div`
    position: absolute;
    top: 0; bottom: 0; left: 0; right: 0;
    background: #000;
    opacity: 0.2;
    z-index: 999;
`
const NutzungsrichtlinienContent = styled.div`
    position: absolute;
    z-index: 999;
    top: 10%;
    max-height: 100%;

    overflow: hidden;

    #policy-text {
        max-height: 500px;
        overflow-y: auto;
        border-bottom: 1px solid #eee;
    }

    max-width: 100%;
    left: calc(50% - 500px);
    right: calc(50% - 500px);

    @media (max-width: 991px) {
        left: 20px;
        right: 20px;
        #policy-text {
            max-height: 400px;
        }
    }

    background-color: #f9f9f9;
    color: #000;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 5px;
    transition: opacity 0.3s;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    line-height: 32px;

    h4 { 
        margin-bottom: 0; 
    }
    input {
        background: #008334;
        margin-top: 20px;
        color: white;
        cursor: pointer;
        border: none;
        padding: 10px;
    }
    
`

const InitialBotInfoDiv = styled.div`
    background: #CCE6D6; border-radius: 20px;
    width: 70%; padding: 30px; margin: 20px auto 50px auto;
    

    @media (max-width: 768px) {
        padding: 20px; margin: 20px 0 50px 0;
        width: calc(100% - 40px);
    }
    h1 {
        margin: 0; margin-bottom: 20px;
        font-size: 38px; font-weight: 200; line-height: 1.2em;
        @media (max-width: 1023px) {
            font-size: 30px;
        }
        @media (max-width: 600px) {
            font-size: 26px;
        }
    }
    a.btn {
        background-color: #fff;
        border-color: #000;
        color: #000;
        border: 1px solid #000;
        border-radius: 24px;
        white-space: normal;
        font-size: 16px;
        text-align: left;
        padding: 8px 20px;
        text-decoration: none;
        display: -webkit-inline-flex;
        -webkit-justify-content: center;
        -webkit-align-items: center;
        display: -moz-inline-flex;
        -moz-justify-content: center;
        -moz-align-items: center;
        @media (max-width: 600px) {
            padding: 8px 15px;
        }
        @media (max-width: 480px) {
            width: calc(100% - 30px);
            padding: 8px 15px;
        }
        &:first-child {
            margin-right: 20px;
            @media (max-width: 480px) {
                margin-right: 0; margin-bottom: 15px;
            }
        }
        &:hover {
            background-color: #008334;
            border-color: #000;
            color: #fff;
            text-decoration: none !important;
        }
    }
    p:last-child {
        margin-bottom: 0;
    }
`;

type InitialBotInfoProps = {

};

const Nutzungsrichtlinien = ({ onClose }: { onClose: () => void }) => {
    return (
        <>
            <NutzungsrichtlinienContainer onClick={onClose} />
            <NutzungsrichtlinienContent>
                <h2>Nutzungsbedingungen</h2>
                <div id="policy-text">
                <p>
                    Die KI-Suche soll Ihnen helfen, Antworten auf Fragen rund um die Verwaltung des Kantons St.Gallen zu erhalten. Sie können Ihre Fragen in frei formulierter Sprache und in nahezu jeder Sprache stellen – die KI-Suche versteht und beantwortet sie entsprechend. Die Antworten basieren auf einer künstlichen Intelligenz und sind daher nicht immer vollständig oder fehlerfrei. Bitte lesen Sie vor der Nutzung die folgenden Nutzungsbedingungen durch. Es gilt ergänzend die allgemeine Datenschutzerklärung von sg.ch.
                </p>
                <h4>Umfang</h4>
                <p>
                    Die KI-Suche greift auf öffentlich zugängliche Inhalte der offiziellen Website des Kanton St.Gallen sg.ch zu und erleichtert den Zugang zu relevanten Informationen.
                </p>
                <h4>Vorsicht bei der Dateneingabe</h4>
                <p>
                    Geben Sie in der KI-Suche keine persönlichen Daten oder sonstige vertrauliche Informationen ein. Die KI-Suche verarbeitet alle Anfragen automatisiert, ohne individuelle Prüfung oder Schutzmechanismen für Personendaten. Zum Schutz Ihrer Privatsphäre sollten Sie sich bei persönlichen Anliegen direkt an die zuständigen kantonalen Stellen wenden.
                </p>
                <p>
                    Die KI-Suche verarbeitet die Informationen, die Sie im Rahmen Ihrer Nutzung bereitstellen. Dazu gehören die von Ihnen eingegebenen Fragen und Antworten. Fragen und Antworten werden in der Testphase gespeichert und dazu verwendet, die KI-Suche sowie den Inhalt auf der Website sg.ch zu verbessern. Ihre Fragen und Antworten sind für einen geschlossenen Nutzerkreis der Kantonsverwaltung einsehbar. Es werden keine Nutzerprofile angelegt. Stattdessen erhält jede Sitzung eine zufällig generierte Sitzungs-ID.
                </p>
                <h4>Datenverarbeitung und -weitergabe</h4>
                <p>
                    Zur Verbesserung der Applikation werden die gestellten Fragen sowie die generierten Antworten gespeichert und analysiert.
                </p>
                <p>
                    Die KI-Suche basiert auf der LLM-Technologie (Large Language Models) des US-amerikanischen Softwareunternehmens OpenAI. Informationen, einschliesslich Personendaten, die Sie uns über die Chatfunktion zu Verfügung stellen, werden an OpenAI weitergegeben, um uns bei der Bereitstellung unserer Dienste zu helfen. Durch die Nutzung der Applikation erklären Sie sich mit dieser Verarbeitung einverstanden.
                </p>
                <h4>Prüfung der Antworten über Links</h4>
                <p>
                    Da die KI-Suche auf künstlicher Intelligenz basiert, kann es vorkommen, dass Antworten ungenau, unvollständig oder sachlich falsch sind. Auch wenn eine Antwort plausibel erscheint, ist sie nicht zwingend korrekt. Prüfen Sie deshalb die Antworten anhand der Links, die als Quellen unter der Antwort angegeben werden.
                </p>
                <h4>Rechtsverbindliche Auskünfte und Anlaufstellen</h4>
                <p>
                    Auskünfte können nicht korrekt sein. Wenden Sie sich deshalb bei Auskünften mit rechtsverbindlichem Charakter direkt an die zuständigen kantonalen Stellen. Bei persönlichen Anliegen wenden Sie sich bitte an die zuständigen kantonalen Behörden.
                </p>
                <h4>Änderungen der Nutzungsbedingungen</h4>
                <p>
                    Der Kanton St.Gallen behält sich vor, diese Nutzungsbedingungen jederzeit zu überarbeiten. Änderungen werden auf dieser Seite veröffentlicht. Es liegt in der Verantwortung der Nutzenden, sich über Aktualisierungen zu informieren.
                </p>
                <h4>Nur für rechtmässige Zwecke</h4>
                <p>
                    Die Nutzung dieses Dienstes ist nur für rechtmässige Zwecke gestattet. Jeglicher Missbrauch, insbesondere für illegale Aktivitäten oder die Verbreitung schädlicher Inhalte, ist untersagt.
                </p>
                <h4>Testphase</h4>
                <p>
                    Die KI-Suche befindet sich in einer Testphase bis 28. Mai 2025. Wir freuen uns über Ihr Feedback, um den Service weiter zu verbessern.
                </p>
                </div>
                <p style={{ textAlign: 'center' }}>
                    <input type="button" value="Schliessen" onClick={onClose} />
                </p>
            </NutzungsrichtlinienContent>
        </>
    )
}
export const InitialBotInfo: React.FC<InitialBotInfoProps> = () => {
    const { testPhaseExpiredMode } = useContext(ConversationContext);
    const [showPolicies, setShowPolicies] = useState(false);

    if (testPhaseExpiredMode) {
        return (
            <InitialBotInfoDiv>
                <h1>Testphase abgeschlossen – vielen Dank für Ihr Feedback!</h1>
                <p>Die Testphase der neuen KI-Suche ist beendet (28. April bis 28. Mai 2025).</p>
                <p>Wir danken allen, die die Suche ausprobiert und ihre Rückmeldungen mit uns geteilt haben. Die zahlreichen Rückmeldungen werden nun ausgewertet und fliessen in die Weiterentwicklung der Suchfunktion ein.</p>
            </InitialBotInfoDiv>
        );
    }
    return (
        <>
            <InitialBotInfoDiv>
                <h1>Fragen Sie die KI-Suche in Ihrer Sprache zum Kanton St.Gallen</h1>
                <p>Ich habe die fast 20'000 Seiten und Dokumente auf sg.ch gelesen - damit Sie es nicht m&uuml;ssen.</p>
                <p>Doch ich lerne noch und mache Fehler. &Uuml;berpr&uuml;fen Sie meine Antwort im Zweifelsfall. Ihr Feedback hilft mir, besser zu werden.</p>
                <p>Geben Sie in der KI-Suche keine persönlichen Daten ein.</p>
                <p>
                    <a className="btn" title="Nutzungsbedingungen" href="/" onClick={e => { setShowPolicies(true); e.preventDefault(); }}>Nutzungsbedingungen</a>
                    <a className="btn" href="https://www.sg.ch/f/datenschutz-sg-ch.html" title="Datenschutzerkl&auml;rung" target="_blank" rel="noreferrer">Datenschutzerkl&auml;rung</a>
                </p>
            </InitialBotInfoDiv>
            {showPolicies && <Nutzungsrichtlinien onClose={() => setShowPolicies(false)} />}
        </>
    )
}